// LiveAgent domain slice (escalation state) — field-ownership rationale in
// .claude/context/live-agent.md's "The domain slice (slice.js)" section.
export const liveAgentSlice = (set) => ({
  isEscalated: false,
  isAgentConnected: false,
  setIsEscalated: (value) => set({ isEscalated: value }, 'setIsEscalated'),
  setIsAgentConnected: (value) => set({ isAgentConnected: value }),
  isAgentTyping: false,
  setIsAgentTyping: (value) => set({ isAgentTyping: value }),
  surveyOverlayUrl: null,
  setSurveyOverlayUrl: (url) => set({ surveyOverlayUrl: url }),
});
